// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ResetPasswordConfirmation.css */
.signin-return {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  background: white;
  height: 100vh;
}
.signin-return .reset-password-confirmation-container {
  max-width: fit-content;
  margin: auto;
  padding: 40px 50px;
  border: 1px solid #ccc;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  margin-top: 10%;
}
.signin-return .forget_popup {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #0c3688;
}
.signin-return h2 {
  text-align: center;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 2rem;
  color: #0c3688;
}
.signin-return p {
  color: #555;
  margin-bottom: 10px;
}
.signin-return span {
  display: block;
  text-align: center;
  text-decoration: underline;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 10px 15px;
  border: none;
  cursor: pointer;
  margin-top: 34px;
  width: auto;
  height: 50px;
  border-radius: 5px;
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  font-family: "Poppins";
  font-size: 18px;
  color: #ffffff;
}
.signin-return a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/component/returnsignin/returnsignin.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;AACF;AACE;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;AACJ;AACE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACJ;AAEE;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAGE;EACE,WAAA;EACA,mBAAA;AADJ;AAIE;EACE,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,uCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mEAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;AAFJ;AAKE;EACE,0BAAA;AAHJ","sourcesContent":["/* ResetPasswordConfirmation.css */\r\n.signin-return {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  background: white;\r\n  height: 100vh;\r\n\r\n  .reset-password-confirmation-container {\r\n    max-width: fit-content;\r\n    margin: auto;\r\n    padding: 40px 50px;\r\n    border: 1px solid #ccc;\r\n    background:#ffffff;\r\n    border-radius: 5px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    margin-top: 10%;\r\n  }\r\n  .forget_popup{\r\n    font-family: \"Nunito\";\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 1rem;\r\n    color: #0c3688;\r\n  }\r\n\r\n  h2 {\r\n    text-align: center;\r\n    font-family: \"Nunito\";\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    font-size: 2rem;\r\n    color: #0c3688;\r\n  }\r\n\r\n  p {\r\n    color: #555;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  span {\r\n    display: block;\r\n    text-align: center;\r\n    text-decoration: underline;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n    padding: 10px 15px;\r\n    border: none;\r\n    cursor: pointer;\r\n    margin-top: 34px;\r\n    width: auto;\r\n    height: 50px;\r\n    border-radius: 5px;\r\n    background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\r\n    font-family: \"Poppins\";\r\n    font-size: 18px;\r\n    color: #ffffff;\r\n  }\r\n\r\n  a:hover {\r\n    text-decoration: underline;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
